export default function Analytics() {
    return (
        <div>
            <h2>Analytics</h2>
        </div>
    )
}
